/******************************************************
 *                  Timetables Ctrl
 ********************************************************/
"use strict";

import dayjs from "dayjs";

angular.module("exploitation")

	.controller("ExploitTimetablesEditOrNewParentCtrl", ["$scope", "ExploitTimetablesService", "toastr",
		function ($scope, ExploitTimetablesService, toastr) {

		/******************************************************
             *                  SETUP
             ********************************************************/
		$scope.data = {
			editedTimetable: {
				periods: [],
				calendarDays: [],
				dayTypes: []
			},
			isOpenedStartDate: false,
			isOpenedEndDate: false,
			isOpenedPeculiarIncludedDate: false,
			isOpenedPeculiarExcludedDate: false
		};

		var DATE_PICKER_FORMAT = "dd/MM/yyyy";

		var initialState = angular.copy($scope.data);

		$scope.open = function ($event, isOpened) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.data[isOpened] = true;
		};

		$scope.format = DATE_PICKER_FORMAT;


		/******************
             * SCOPE FUNCTIONS
             ******************/

		/**
             * Ajouter une période au calendrier.
             * @param startDate Date de début de la période.
             * @param endDate Date de fin de la période.
             */
		$scope.addPeriod = function (startDate, endDate) {
			$scope.data.editedTimetable.periods.push({startDate: startDate, endDate: endDate});
			if ($scope.data.form) {
				$scope.data.form.startDate = undefined;
				$scope.data.form.endDate = undefined;
			}

		};

		/**
             * Inclure une date particulière dans le calendrier.
             * @param date la date à inclure.
             */
		$scope.includeDate = function (date) {
			$scope.data.editedTimetable.calendarDays.push({"date": date, "included": true});
			$scope.data.form.peculiarIncludedDate = undefined;
		};

		/**
             * Exclure une date partoculière du calendrier.
             * @param date la date à exclure.
             */
		$scope.excludeDate = function (date) {
			$scope.data.editedTimetable.calendarDays.push({"date": date, included: false});
			$scope.data.form.peculiarExcludedDate = undefined;
		};

		$scope.shouldDisplayIncludedDays = function (days) {
			return days.some(function (day) {
				return day.included;
			});
		};

		$scope.shouldDisplayExcludedDays = function (days) {
			return days.some(function (day) {
				return !day.included;
			});
		};

		$scope.postTimetable = function (form, newCalendarData) {

			if ($scope.data.mode === "add") {

				ExploitTimetablesService.addTimetable(newCalendarData).then((response) => {
					const data = response.data;
					toastr.success("<a href=\"#/e-iti/timetables/" + data.id + "\">Cliquez ici pour accéder au calendrier</a>", "Calendrier créé", {allowHtml: true});
					$scope.data = initialState;
					$scope.data.mode = "add";
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la création du calendrier. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				ExploitTimetablesService.editTimetable(newCalendarData).then((response) => {
					const data = response.data;
					toastr.success("<a href=\"#/e-iti/timetables/" + data.id + "\">Cliquez ici pour accéder au calendrier</a>", "Calendrier " + data.version + " mis à jour", {allowHtml: true});
					$scope.data.editedTimetable = data;
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour du calendrier. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


		/**
             * Mettre à jour le tableau contenant les jours sélecitonnés pour le calendrier en cours de création.
             * @param dayName
             */
		$scope.toggleDaysSelection = function toggleDaysSelection(dayName) {
			var idx = $scope.data.editedTimetable.dayTypes.indexOf(dayName);

			// déjà sélectionné => on désélectionne
			if (idx > -1) {
				$scope.data.editedTimetable.dayTypes.splice(idx, 1);
			}

			// l'inverse
			else {
				$scope.data.editedTimetable.dayTypes.push(dayName);
			}
		};


		/**
             * Couleur d'un item :
             * - vert : en cours, expire dans plus d'un mois
             * - orange : en cours, expire dans moins d'un mois
             * - rouge: expiré
             * @param endOfPeriod
             * @returns {*}
             */
		$scope.getTimetableCardColor = function (endOfPeriod) {

			if (dayjs(endOfPeriod).diff(dayjs()) < 0) {
				// Calendrier écoulé
				return ("-danger");

			} else if (dayjs(endOfPeriod).diff(dayjs().add(1, "month")) < 0) {
				// Calendrier échéance dans moins d'un mois
				return ("-warning");

			} else if (dayjs(endOfPeriod).diff(dayjs()) > 0) {
				return ("-success");

			} else {
				// Pb sur le calcul des dates
				return ("panel-danger");
			}
		};


		/**
             * Couleur d'une case dans le calendrier
             *
             * TODO : fonctionne pas. Version datepicker ???
             * @param date
             * @param mode
             * @returns {*}
             */
		$scope.getDayClass = function (date, mode) {
			if (mode === "day") {
				if (isDayAlreadyIncludedInPeriod(date)) {
					return "already-in-period";
				}
			}
			return "";
		};


		/**
             * Vérifie qu'au moins une unité de temps est renseignée : au moins une journée inclue, ou bien une période.
             * @returns {boolean} true si au moins une unité de temps inclue.
             */
		$scope.isThereAtLeastOnePeriodOrDay = function () {
			return ($scope.shouldDisplayIncludedDays($scope.data.editedTimetable.calendarDays) || ($scope.data.editedTimetable.periods && $scope.data.editedTimetable.periods.length > 0));
		};


		/******************
             * UTILS
             ******************/


		/**
             * Est-ce qu'un jour donné est inclus dans une des périodes déjà définie par l'utilisateur ?
             * @param day Le jour à vérifier.
             */
		var isDayAlreadyIncludedInPeriod = function (day) {
			var dayMoment = dayjs(day);
			for (var i = 0; i < $scope.data.editedTimetable.periods.length; i++) {
				var period = $scope.data.editedTimetable.periods[i];
				if (dayjs(period.startDate).isBefore(dayMoment) && dayjs(period.endDate).isAfter(dayMoment)) {
					return true;
				}
			}
			return false;
		};
	}]
	)
;
